import React, { useContext, useState } from 'react';
import ReactLoading from 'react-loading';

import CustomModal from '../shared/CustomModal';
import OnHoverTooltip from '../shared/OnHoverTooltip';
import { DeepCopy } from '../shared/TableEventHelpers';

import RemarkInput from './RemarkInput';
import { HandleAddRemark } from './requests/RemarkRequests';

import { DataContext } from '../../../stores/covering-table-store';
import TextareaAutosize from 'react-textarea-autosize';

const RemarkContainer = ({ isNameShowing, row }) => {
    const {
        store: { coverings },
        dispatch,
    } = useContext(DataContext);

    const [isAdding, setIsAdding] = useState(false);
    const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');
    const [editableDivContent, setEditableDivContent] = useState('');

    async function handleAddingComment(empID) {
        let newCommentDivContainer = document.getElementById(empID + '-new-comment-div-container');
        newCommentDivContainer.style.height = newCommentDivContainer.clientHeight.toString() + 'px';

        let dsc = DeepCopy(editableDivContent);
        setEditableDivContent('');

        if (dsc !== '') {
            setIsAdding(true);
            let addResult = await HandleAddRemark(empID, dsc, coverings, row, setIsAdding, dispatch);

            if (!addResult.error) {
                dispatch({ type: 'SHOW_SAVED_TOAST' });
            } else {
                if (dsc !== '') {
                    setAlertModalContent(addResult.error);
                    setIsAlertModalOpen(true);
                }
            }
        }

        newCommentDivContainer.style.height = 'auto';
        HandleNewEditableDiv(empID, false);
    }

    return (
        <>
            {isNameShowing ? (
                <>
                    <OnHoverTooltip
                        labelClassNames='add-remark-button c-light-grey'
                        dataFor={row['empID'] + '-comment-section-button'}
                        tooltipType='light'
                        tooltipPlace='right'
                        tooltipEffect='solid'>
                        <div
                            className='border-0'
                            onClick={() => {
                                HandleNewEditableDiv(row['empID'], true);
                            }}>
                            <span className='oi oi-comment-square d-flex justify-content-left' />
                        </div>
                        <span>Lägg till anteckning</span>
                    </OnHoverTooltip>
                    <div className='d-flex flex-column' style={{ minWidth: '230px' }}>
                        {row['remarks'].length > 0 ? (
                            <div>
                                {row['remarks'].map((element) => (
                                    <RemarkInput
                                        id={row['empID'] + '-remark-' + element.remID}
                                        key={row['empID'] + '-remark-' + element.remID}
                                        row={row}
                                        element={element}
                                        setIsAlertModalOpen={setIsAlertModalOpen}
                                        setAlertModalContent={setAlertModalContent}
                                    />
                                ))}
                            </div>
                        ) : null}
                        <div id={row['empID'] + '-new-comment-div-container'} className='remark-editable-div d-none bg-yellow w-100'>
                            {isAdding ? (
                                <SavingLoader />
                            ) : (
                                <TextareaAutosize
                                    id={row['empID'] + '-remark-editable-div'}
                                    className='bg-yellow border-0 h-100 w-100 no-scroll-bar outline-none'
                                    maxLength='200'
                                    minRows={1}
                                    onInput={(e) => {
                                        setEditableDivContent(e.currentTarget.value);
                                    }}
                                    onBlur={() => handleAddingComment(row['empID'])}
                                    style={{ resize: 'none' }}
                                    wrap='hard'
                                />
                            )}
                        </div>
                    </div>
                </>
            ) : null}
            <div className='covering-modals'>
                {isAlertModalOpen ? (
                    <CustomModal
                        show={isAlertModalOpen}
                        onHide={() => setIsAlertModalOpen(false)}
                        handleModal={() => {}}
                        modalText={alertModalContent}
                        buttonText={null}
                        buttonClassName='d-none'
                        modalVariant='danger'
                    />
                ) : null}
            </div>
        </>
    );
};

export default RemarkContainer;

const SavingLoader = () => {
    return (
        <div className='d-flex justify-content-center align-items-center h-100'>
            <ReactLoading type={'bars'} color={'#262f3d'} height={25} width={25} />
        </div>
    );
};

const HandleNewEditableDiv = (empID, isShowing) => {
    if (isShowing) {
        let newCommentDivContainer = document.getElementById(empID + '-new-comment-div-container');
        let newCommentDiv = document.getElementById(empID + '-remark-editable-div');

        if (newCommentDivContainer) {
            newCommentDivContainer.className += ' unset-display';
        }
        if (newCommentDiv) {
            newCommentDiv.focus();
        }
    } else {
        let newCommentDivContainer = document.getElementById(empID + '-new-comment-div-container');

        if (newCommentDivContainer) {
            newCommentDivContainer.className = 'remark-editable-div d-none bg-yellow';
        }
    }
};
